// ------------------------------------------------------------------
// IRON GRIT BOSTON — central mock data file
// All site content lives here. Replace values as the brand evolves.
// ------------------------------------------------------------------

export const CHALKIT_URL =
  "https://app.chalkitpro.com/gymProductLink/876/prod_US0f8ShRgW0079/15027/";

// ChalkIt Pro app login — existing members reserve classes here
export const CHALKIT_MEMBER_URL = "https://app.chalkitpro.com/";

// Per-product ChalkIt Pro checkout links (from owner's CSV, Aug 2026); null falls back to CHALKIT_URL (Platinum Membership)
export const CHALKIT_PRODUCTS = {
  unlimited: "https://app.chalkitpro.com/gymProductLink/876/prod_US0f8ShRgW0079/15027/",
  "3x": "https://app.chalkitpro.com/gymProductLink/876/prod_SjYN5LwOH2NIig/10790/",
  heroes: null,
  big365: "https://app.chalkitpro.com/gymProductLink/876/prod_V5iCGldQOmyAwa/16471/",
  punch10: "https://app.chalkitpro.com/gymProductLink/876/prod_SjYI7ZbTAIxTOm/10786/",
  punch30: "https://app.chalkitpro.com/gymProductLink/876/prod_SlOtokaRDJxwsR/10832/",
  punch52: "https://app.chalkitpro.com/gymProductLink/876/prod_SlOxxPtohiEFjZ/10833/",
  pt5: "https://app.chalkitpro.com/gymProductLink/876/prod_SjYSQJe1ZjU35Y/10792/",
  pt10: "https://app.chalkitpro.com/gymProductLink/876/prod_SvrVHzdC4wHjOi/11139/",
  fundamentals: "https://app.chalkitpro.com/gymProductLink/876/prod_SjYRCQshVJ4ewf/10791/",
  hyroxAddOn: "https://app.chalkitpro.com/gymProductLink/876/prod_V5bST1vISQw4dY/16443/",
  hyroxPunchMembers: "https://app.chalkitpro.com/gymProductLink/876/prod_V5cGDVd8CjI0GI/16445/",
  hyroxPunch24: "https://app.chalkitpro.com/gymProductLink/876/prod_V5bXvALHwoGylJ/16444/",
  dropIn: "https://app.chalkitpro.com/dropIns/876/10793/x",
  goalReview: "https://app.chalkitpro.com/dropIns/876/16511/x",
  dropInWeek: "https://app.chalkitpro.com/gymProductLink/876/prod_SjYVXxEtEon9Ro/10794/",
  labsMen: "https://app.chalkitpro.com/productsstore/prod_UsbcGGiL9oyDft",
  labsWomen: "https://app.chalkitpro.com/productsstore/prod_UsbrfCpKphjJ3j",
  goldFoundation: "https://app.chalkitpro.com/gymProductLink/876/prod_Uy81Z5W7mlrAz2/16141/",
  goldAscension: "https://app.chalkitpro.com/gymProductLink/876/prod_Uy8ir9mgnUyaGu/16142/",
  goldElite: "https://app.chalkitpro.com/gymProductLink/876/prod_Uy8lK411Lv54aN/16143/",
};

export const chalkitLink = (key) => CHALKIT_PRODUCTS[key] || CHALKIT_URL;

export const SITE = {
  name: "Boston Iron Grit",
  legalName: "Boston Iron Grit",
  tagline: "Forged in West Roxbury",
  motto: "Live B.I.G. 365",
  url: "https://bostonirongrittraining.com",
  phone: "617-637-8900",
  phoneHref: "tel:6176378900",
  smsHref: "sms:6176378900",
  email: "info@crossfitbostonirongrit.com",
  address: {
    street: "1230 VFW Parkway",
    unit: "On Sambuca Way Alley",
    city: "West Roxbury",
    state: "MA",
    zip: "02132",
    full: "1230 VFW Parkway, West Roxbury, MA 02132",
  },
  geo: { lat: 42.2769, lng: -71.1554 },
  mapsUrl: "https://www.google.com/maps/search/?api=1&query=1230+VFW+Parkway+West+Roxbury+MA+02132",
  gbpUrl: "https://g.page/r/CUKXEGs2n-0pEBM",
  reviewUrl: "https://g.page/r/CUKXEGs2n-0pEBM/review",
  founded: "2011",
  social: {
    instagram: "https://www.instagram.com/crossfitbostonirongrit/",
    facebook: "https://www.facebook.com/crossfitbostonirongrit/",
    crossfit: "https://www.crossfit.com/affiliate/1360/crossfit-boston-iron-grit",
  },
  hours: [
    { days: "Monday – Friday", time: "5:15 AM – 7:30 PM" },
    { days: "Saturday", time: "8:00 AM – 12:00 PM" },
    { days: "Sunday", time: "9:00 AM – 12:00 PM" },
  ],
  serviceAreas: ["West Roxbury", "Dedham", "Roslindale", "Brookline", "Needham", "Newton", "Jamaica Plain", "Hyde Park"],
};

export const IMG = {
  hero: "/images/gym/hero-barbell.jpg",
  pullups: "/images/gym/pullup-woman.jpg",
  group: "/images/gym/community-dumbbells.jpg",
  happy: "/images/gym/happy-member.jpg",
  adaptive: "/images/coaches/cass-adaptive.jpg",
  coach: "/images/gym/coaching-bench.webp",
  chalk: "/images/gym/db-snatch.jpg",
  kettlebell: "/images/gym/kb-swing.jpg",
  rigClimb: "/images/gym/rig-climb.jpg",
  goldLift: "/images/gym/gold-lift.jpg",
  plateLoad: "/images/gym/plate-load.jpg",
  rower: "/images/gym/rower.webp",
  interior: "/images/gym/class-wide.jpg",
  fundamentals: "/images/gym/wallball-squat.jpg",
  oly: "/images/gym/masters-clean-2.jpg",
  pt: "/images/gym/coaching-bench.webp",
  nutrition: "https://images.unsplash.com/photo-1512621776951-a57141f2eefd?auto=format&fit=crop&w=1600&q=80",
  teen: "https://images.pexels.com/photos/4853301/pexels-photo-4853301.jpeg?auto=compress&cs=tinysrgb&w=1600",
  womens: "/images/gym/squat-bw.jpg",
  senior: "/images/gym/masters-clean.jpg",
  hyroxSandbag: "https://images.unsplash.com/photo-1779126751423-e47215ec02e6?auto=format&fit=crop&w=1920&q=80",
  hyroxRun: "/images/gym/wallball-coaching.jpg",
  sleep: "https://static.prod-images.emergentagent.com/jobs/67cf3e57-f776-4287-8e73-4d62b3ad419c/images/fedaeaf6b9da04586cc26a8725ce09ae78b9783bf1a9a4cf04426ec690d8f70b.jpeg",
  hydration: "https://static.prod-images.emergentagent.com/jobs/67cf3e57-f776-4287-8e73-4d62b3ad419c/images/f420e9abe1cd4270b39fee3dc7a5a418bf3970f080bf0e1b4039c40a29c8ed6a.jpeg",
  bigEngineLogo: "https://customer-assets-agu9un31.emergentagent.net/job_grit-training-boston/artifacts/o8pvq4rh_Screen%20Shot%202026-08-06%20at%208.29.29%20PM.png",
};

export const PROOF = [
  { value: "2011", label: "Affiliated since" },
  { value: "5.0", label: "Google rating" },
  { value: "15+", label: "Years coaching Boston" },
  { value: "100%", label: "Beginner-friendly scaling" },
];

export const TESTIMONIALS = [
  {
    quote:
      "World class coaching, facility & people. I've trained here for the past year and love it. The coaches are all phenomenal and can tailor every workout to meet you where you're at. Big shout out to Miguel — his early morning classes and Olympic lifting sessions are excellent!",
    name: "Gary O'Mahoney",
    tag: "Member, 1+ year",
  },
  {
    quote:
      "Great inspirational people, awesome coaching and truly no judgements. It's a community of all sorts of athletic abilities, shapes, sizes and ages — everyone is welcome. It's my church!",
    name: "Tara Bridget Condon",
    tag: "Member",
  },
  {
    quote:
      "I dropped in for a week and got to experience a motivating and energetic community. Tina, Kina, Miguel, and Brian all made me feel welcome. The gym offers open gym throughout the day, which is a super plus. Strongly recommend to visiting CrossFitters.",
    name: "Randfer Sandlers",
    tag: "Visiting Athlete",
  },
  {
    quote:
      "Everyone is extremely supportive and positive. Miguel has given me tips that have greatly improved skills I struggled with. Tina genuinely wants to create the best experience for each person and help everyone on their individual fitness journey.",
    name: "Wendy Gertel",
    tag: "Member",
  },
];

// Real featured members with hometowns — linked to their spotlight articles
export const NEIGHBOR_QUOTES = [
  { town: "Dedham", name: "Mary, 72", text: "Qualified for the CrossFit Semifinals at 72 — proof that the barbell doesn't check your birth certificate.", slug: "spotlight-mary" },
  { town: "West Roxbury", name: "Jess Rivera-Mendoza", text: "Army veteran, powerlifter and jiu jitsu fighter — the neighbor who helped bring her 'Afghan family' to safety in Boston.", slug: "spotlight-jess" },
  { town: "Dedham", name: "Sukesh Shekar", text: "Noon WOD crusher and clean & jerk devotee whose mortgage company helps first-time buyers become homeowners.", slug: "spotlight-sukesh" },
];

export const COACHES = [
  {
    slug: "tina-ramos",
    name: "Tina Ramos",
    role: "Owner & Head Coach",
    creds: "CF-L2 · Ed.M. Harvard · NPTI",
    photo: "/images/coaches/tina.jpg",
    email: "tina@bostonirongrittraining.com",
    bio: "Tina began her career working with at-risk teens and families, earned her NPTI personal training certificate and CrossFit Level 1 in 2010, and opened the gym in 2011. A former national-level cross country runner with an Ed.M. from Harvard, she built our kids, teen and Fundamentals programs and launched Live B.I.G. 365 in 2024. Her passion for fitness and compassion for people is the driving force behind B.I.G.",
    longBio: [
      "Tina spent the first part of her career working with teens and families in an at-risk program for youth. In 2010 she attended the National Personal Training Institute and earned her personal training certificate. That same year she received her CrossFit Level 1 certificate, and in 2011 she became an affiliate owner.",
      "As a coach, Tina brings her collegiate athletic background — she was a national-level cross country runner and an avid basketball player — plus more than a decade of CrossFit coaching experience. She developed the kids and teen program and the Fundamentals program for beginners, and oversees the management of the gym to bring you the highest level of coaching. Her passion for fitness and her compassion to help others is the driving force behind B.I.G.",
      "In 2024 Tina developed and launched Live B.I.G. 365 — a lifestyle program designed to help you understand your health on the longevity continuum. This is the next level of training in Boston.",
    ],
    certs: ["CrossFit Level 1", "CrossFit Level 2", "CrossFit Kids", "CrossFit Rowing", "CrossFit Kettlebell", "CrossFit Weightlifting", "CrossFit Gymnastics", "CrossFit Defense", "CrossFit Aerobic Capacity"],
    education: ["Hunter College–CUNY, BA Psychology", "Harvard University School of Education, Ed.M.", "National Personal Training Institute, 2010"],
  },
  {
    slug: "miguel-claravall",
    name: "Miguel Claravall",
    role: "Coach · Olympic Lifting",
    creds: "CF-L3 · USAW-L1",
    photo: "/images/coaches/miguel.jpg",
    bio: "Our Olympic lifting and skill development specialist. Known for his technical eye that fixes a lift with one cue.",
    longBio: [
      "As a CrossFit coach and a student of martial arts, Miguel brings his athletes a wonderful disposition and a wealth of knowledge. He has spent years coaching Olympic lifting and taking his athletes to numerous competitions in the area. He believes there is an inner athlete in every person — goals are achieved by learning technique and building better mechanics.",
      "Alongside his CrossFit trainer credentials, Miguel brings the experience of practicing and competing in Brazilian Jiu-Jitsu — an art form built on moving yourself and an object in the most efficient manner. He continues to expand his knowledge of teaching new forms, and brought CrossFit Defense to Iron Grit for members and the wider Boston community.",
    ],
    certs: ["USAW L1 Sport Performance", "CrossFit Level 1", "CrossFit Level 2", "CrossFit Level 3", "CrossFit Gymnastics", "CrossFit Defense", "CrossFit Aerobic Capacity"],
  },
  {
    slug: "brian-conroy",
    name: "Brian Conroy",
    role: "Coach · Aerobic Capacity Specialist",
    creds: "CF-L2 · HYROX Coach",
    photo: "/images/coaches/brian.jpg",
    bio: "Runs the B.I.G. Engine class and programs for the HYROX club. If you want a bigger engine, Coach B is your guy.",
    longBio: [
      "Growing up I played as many games and sports as I could. Though my passion was baseball, I was drawn to all the physical and mental challenges sport presented — regardless of whether I was good.",
      "Long after my days of playing organized sports were gone, I was introduced to the sport of CrossFit. It was like an adult playground and I was immediately hooked. CrossFit bridged the gap to those younger days playing organized sports — in every class I feel like I'm surrounded by teammates.",
      "Whether I'm taking class or coaching it, I'm constantly fueled, inspired and humbled by other athletes, regardless of their experience or ability, as we all work toward the common goal of becoming fitter. I'm grateful to be part of the Iron Grit community. 3-2-1, GO!",
    ],
    achievements: ["Played Division I college baseball", "Played 6 years of professional baseball in the Boston Red Sox and Colorado Rockies organizations"],
    certs: ["CrossFit Level 1", "CrossFit Level 2", "CrossFit Gymnastics", "CrossFit Aerobic Capacity"],
  },
  {
    slug: "yohanna-estime",
    name: "Yohanna Estime",
    role: "Coach",
    creds: "CF-L2",
    photo: "/images/coaches/yohanna.jpg",
    bio: "Yohanna brings her warm heart and keen eye on the floor. She assists the B.I.G. Engine classes and competes regularly with the crew.",
    longBio: [
      "I was introduced to CrossFit in the spring of 2013. I wasn't looking for a new way to train — I was active, had a trainer and thought I was physically fit. I had just recovered from arthroscopic knee surgery and didn't think I could keep pace. I walked into a CrossFit gym for a free trial, and after a week I was hooked. I was sore and I loved it!",
      "What I love about CrossFit is the constantly varied workouts — the lifting, the gymnastics skill development, the running and yes, the burpees. Most of all I love the community. We suffer through each workout together, and push and challenge each other to keep moving. This box is my second home and my gym family.",
      "I've competed in powerlifting and Olympic lifting meets — placing on the podium each time — and in many local competitions that fuel my competitive nature. Becoming a coach was a goal of mine, and now I get to spread my love of CrossFit and help other athletes accomplish their own goals at B.I.G.",
    ],
    certs: ["CrossFit Level 1", "CrossFit Level 2", "CrossFit Aerobic Capacity"],
  },
  {
    slug: "marc-tucker",
    name: "Marc Tucker",
    role: "Coach · Powerlifting & Teen Specialist",
    creds: "CF-L2",
    photo: "/images/coaches/marc.jpg",
    bio: "Coach Tuck runs the powerlifting program and specializes in helping teen athletes with sport-specific development.",
    longBio: [
      "Coach Tuck runs the powerlifting program at the Westie Barbell Club and specializes in helping teen athletes with sport-specific development. His sessions are equal parts technique, standards and steady encouragement — the kind of coaching that builds strong lifters and stronger habits.",
      "You'll find him coaching the powerlifting sessions during the week and working with our teen athletes on the fundamentals that carry over to every sport: bracing, hinging, squatting, pressing and sprinting.",
    ],
    certs: ["CrossFit Level 1", "CrossFit Level 2"],
  },
  {
    slug: "cass-eddy-stewart",
    name: "Cassandra Eddy-Stewart",
    role: "Adaptive Coach Specialist",
    creds: "CF-L2 · M.S. Exercise Science",
    photo: "/images/coaches/cass-rowing.jpg",
    bio: "Coach Cass brings her athletic experience and amazing spirit to her coaching. She specializes in training adaptive athletes and competes in HYROX, rowing and CrossFit as an adaptive athlete herself.",
    longBio: [
      "Coach Cass brings her athletic experience and amazing spirit to her coaching. She specializes in training adaptive athletes and competes in HYROX, rowing and CrossFit competitions as an adaptive athlete herself.",
      "Cass has a master's degree in exercise science, applying her knowledge of the human body to training athletes of all levels.",
      "You can find Cass coaching on Wednesday nights.",
    ],
    certs: ["CrossFit Level 2 Trainer", "Master's in Exercise Science", "Level 1 Weightlifting Coach"],
  },
];

// ---------------- Weekly schedule (representative) ----------------
export const SCHEDULE = {
  note: "Reserve your spot through ChalkIt Pro. Open Gym runs 10:30 - 11:30 AM on weekdays -- afternoon times coming soon.",
  days: [
    {
      day: "Monday",
      slots: [
        { time: "5:15 AM", name: "CrossFit", coach: "Miguel" },
        { time: "8:00 AM", name: "CrossFit", coach: "Miguel" },
        { time: "9:30 AM", name: "CrossFit", coach: "Marc" },
        { time: "10:30 AM", name: "Open Gym", coach: "Staffed" },
        { time: "12:00 PM", name: "CrossFit (Noon)", coach: "Marc" },
        { time: "5:00 PM", name: "CrossFit", coach: "Yohanna" },
        { time: "6:30 PM", name: "CrossFit", coach: "Marc" },
      ],
    },
    {
      day: "Tuesday",
      slots: [
        { time: "5:15 AM", name: "CrossFit", coach: "Miguel" },
        { time: "6:30 AM", name: "HYROX", coach: "Tina & Kate" },
        { time: "8:00 AM", name: "CrossFit", coach: "Miguel" },
        { time: "9:30 AM", name: "Powerlifting", coach: "Marc" },
        { time: "10:30 AM", name: "Open Gym", coach: "Staffed" },
        { time: "12:00 PM", name: "CrossFit (Noon)", coach: "Marc" },
        { time: "5:00 PM", name: "CrossFit", coach: "Brian" },
        { time: "6:30 PM", name: "CrossFit", coach: "Brian" },
      ],
    },
    {
      day: "Wednesday",
      slots: [
        { time: "5:15 AM", name: "CrossFit", coach: "Brian" },
        { time: "6:30 AM", name: "Powerlifting", coach: "Marc" },
        { time: "8:00 AM", name: "CrossFit", coach: "Marc" },
        { time: "9:30 AM", name: "CrossFit", coach: "Tina" },
        { time: "10:30 AM", name: "Open Gym", coach: "Staffed" },
        { time: "12:00 PM", name: "CrossFit (Noon)", coach: "Tina" },
        { time: "5:00 PM", name: "CrossFit", coach: "Miguel" },
        { time: "6:30 PM", name: "CrossFit", coach: "Miguel" },
      ],
    },
    {
      day: "Thursday",
      slots: [
        { time: "5:15 AM", name: "CrossFit", coach: "Tina" },
        { time: "6:30 AM", name: "HYROX", coach: "Tina & Kate" },
        { time: "8:00 AM", name: "CrossFit", coach: "Tina" },
        { time: "9:30 AM", name: "Powerlifting", coach: "Marc" },
        { time: "10:30 AM", name: "Open Gym", coach: "Staffed" },
        { time: "12:00 PM", name: "CrossFit (Noon)", coach: "Marc" },
        { time: "5:00 PM", name: "CrossFit", coach: "Brian" },
        { time: "6:30 PM", name: "CrossFit", coach: "Brian" },
      ],
    },
    {
      day: "Friday",
      slots: [
        { time: "5:15 AM", name: "CrossFit", coach: "Marc" },
        { time: "6:30 AM", name: "Powerlifting", coach: "Marc" },
        { time: "8:00 AM", name: "CrossFit", coach: "Miguel" },
        { time: "9:30 AM", name: "CrossFit", coach: "Miguel" },
        { time: "10:30 AM", name: "Open Gym", coach: "Staffed" },
        { time: "12:00 PM", name: "CrossFit (Noon)", coach: "Miguel" },
        { time: "6:00 PM", name: "CrossFit", coach: "Brian & Yohanna" },
      ],
    },
    {
      day: "Saturday",
      slots: [
        { time: "6:30 AM", name: "Olympic Lifting", coach: "Miguel" },
        { time: "8:00 AM", name: "Olympic Lifting", coach: "Miguel" },
        { time: "9:30 AM", name: "HYROX-Hybrid Core & Zone 2", coach: "Miguel" },
      ],
    },
    {
      day: "Sunday",
      slots: [
        { time: "8:00 AM", name: "B.I.G. Engine", coach: "Brian & Yohanna" },
        { time: "10:00 AM", name: "B.I.G. Engine", coach: "Brian & Yohanna" },
      ],
    },
  ],
  openGym: "Open Gym access Monday-Friday 10:30 - 11:30 AM. Afternoon times coming soon!",
};

// ---------------- Pricing (real prices from current pricing page) ----------------
export const PRICING = {
  note: "All memberships are month-to-month. No initiation fees, no long-term contracts. Book securely through ChalkIt Pro.",
  featured: "unlimited",
  plans: [
    {
      id: "unlimited",
      name: "Platinum Membership",
      price: "$275",
      per: "/month",
      blurb: "Unlimited classes — every class we run, plus the full Live B.I.G. 365 wellness program built in.",
      features: ["Unlimited CrossFit classes", "Olympic Weightlifting & HYROX Club", "Live B.I.G. 365 Wellness Program included", "Special pricing for lab tests & peptides", "Open Gym access", "Free parking & showers"],
      cta: "Join Platinum",
    },
    {
      id: "3x",
      name: "3x / Week",
      price: "$225",
      per: "/month",
      blurb: "CrossFit classes three times per week — the sweet spot for busy schedules.",
      features: ["3 CrossFit classes per week", "Any class time on the schedule", "Beginner-friendly scaling", "Free parking & showers"],
      cta: "Join 3x/Week",
    },
    {
      id: "big365",
      name: "Live B.I.G. 365",
      price: "$100",
      per: "/month",
      blurb: "Our 8-daily-habits wellness program — coaching for the other 23 hours of your day.",
      features: ["Included with the Platinum Membership", "Special pricing for peptides & GLP-1s", "Special pricing for lab tests & body composition", "Journals, easy-to-use app & nutrition advice", "Support every step of your health journey"],
      cta: "Join Live B.I.G. 365",
      learnMore: "/live-big-365",
    },
    {
      id: "heroes",
      name: "Heroes Platinum",
      price: "$225",
      per: "/month",
      blurb: "Veterans, first responders & family discount — the full Platinum membership with unlimited classes.",
      features: ["Everything in Platinum", "For veterans & first responders", "Family members qualify too", "Our thank-you for your service"],
      cta: "Claim Heroes Rate",
    },
  ],
  punchCards: {
    blurb: "Flexibility & accountability. Wellness Program discounts apply to member punch cards. Training for HYROX? The 24-session HYROX card covers B.I.G. Engine, Powerlifting, HYROX Comp Prep and Saturday race prep — $480 for members, $600 for new athletes.",
    options: [
      { classes: "10", price: "$300", exp: "3-month expiration" },
      { classes: "30", price: "$750", exp: "8-month expiration" },
      { classes: "52", price: "$1,040", exp: "12-month expiration" },
    ],
  },
  privateTraining: [
    { sessions: "5", price: "$750", note: "Perfect for a skill-focused block" },
    { sessions: "10", price: "$1,250", note: "Our most popular package" },
    { fundamentals: true, name: "Fundamentals · Beginner Program", sub: "5 Sessions", price: "$625", note: "Includes InBody Analysis & Assessment Session" },
  ],
  fundamentals: [
    { name: "Goal Review", price: "FREE", note: "Get started by reviewing your goals" },
  ],
  extras: [
    { name: "HYROX Add-On (Current Members)", price: "$50/month", note: "Add HYROX training to any membership — month to month. Train for HYROX Boston, October 8–11." },
    { name: "HYROX Punch Card (Members)", price: "$480", note: "24 sessions at the members-only discount — B.I.G. Engine, Powerlifting, HYROX Comp Prep and Saturday race prep." },
    { name: "HYROX Punch Card (New Athletes)", price: "$600", note: "24 sessions — B.I.G. Engine, Powerlifting, HYROX Comp Prep and Saturday race prep." },
    { name: "Drop-In (Visiting Athlete)", price: "$35/class", note: "Experienced CrossFit athletes only — book ahead. Week pass available for $75.", link: "/drop-in" },
  ],
};

// ---------------- Programs / class pages ----------------
export const CLASSES = [
  {
    slug: "crossfit",
    metaDescription: "Coached one-hour CrossFit classes in West Roxbury, Monday to Friday from 5:15 AM to 6:30 PM. Every workout scales to your level — beginners welcome.",
    offerPrice: "275",
    name: "CrossFit",
    short: "Coached group classes that blend strength and conditioning. Scaled to every level, every day.",
    image: IMG.interior,
    heroLabel: "Group Classes",
    answer:
      "CrossFit at Boston Iron Grit is a one-hour coached class in West Roxbury combining strength work and conditioning. Every workout is scaled to your ability — beginners and 15-year veterans train side by side. Classes run from 5:15 AM to 6:30 PM on weekdays.",
    whoFor: [
      "Anyone who wants coached, programmed training instead of guessing at the gym",
      "Athletes who thrive on community energy and a little friendly competition",
      "Busy people who want maximum results in exactly one hour",
      "Beginners — every single movement can be scaled",
    ],
    session: [
      { name: "Briefing", detail: "Coach walks through the day's goal, movements and scaling options.", mins: "5 min" },
      { name: "Warm-Up", detail: "Raise your temperature and rehearse the patterns you'll use.", mins: "10 min" },
      { name: "Strength / Skill", detail: "Focused barbell or gymnastics work with individual coaching.", mins: "20 min" },
      { name: "The Workout", detail: "The conditioning piece — scaled to you, pushed by the room.", mins: "20 min" },
      { name: "Cool-Down", detail: "Mobility, accessory work and high fives.", mins: "5 min" },
    ],
    scheduleNote: "Classes daily Mon–Fri, 5:15 AM – 6:30 PM",
    priceNote: "Included in the Platinum Membership ($275/mo) and 3x/Week ($225/mo) memberships.",
    coachName: "All coaches",
    faqs: [
      { q: "Do I need to be in shape before starting CrossFit?", a: "No. Every workout is scaled to your current ability. Beginners start with a goal review and fundamentals sessions before joining classes." },
      { q: "How long is a class?", a: "Exactly one hour: briefing, warm-up, strength or skill work, the conditioning workout, and a cool-down." },
      { q: "Will I have to lift heavy weights?", a: "No. You learn technique first with light loads and progress gradually. Coaches choose weights appropriate to your level." },
      { q: "What should I bring to class?", a: "Water, comfortable training clothes and stable athletic shoes. No specialty gear needed on day one." },
      { q: "How often should a beginner come?", a: "Two or three sessions a week is a realistic starting point. Consistency beats intensity." },
    ],
    relatedArticle: "crossfit-for-beginners-boston",
  },
  {
    slug: "olympic-weightlifting",
    metaDescription: "Olympic lifting classes at the Westie Barbell Club in West Roxbury: snatch and clean & jerk coaching every Saturday at 6:30 and 8:00 AM. All levels welcome.",
    offerPrice: "275",
    name: "Olympic Lifting",
    short: "Westie Barbell Club: a dedicated Saturday hour on the snatch and the clean & jerk.",
    image: IMG.oly,
    heroLabel: "Westie Barbell Club",
    answer:
      "Olympic Lifting at Boston Iron Grit is a Westie Barbell Club class in West Roxbury that meets every Saturday morning for a dedicated hour on the snatch and the clean & jerk. It's a great class for beginners learning the basics and for competitors after extra technique work. Saturday 6:30 AM and 8:00 AM.",
    whoFor: [
      "CrossFit athletes who want focused technique time on the barbell",
      "Beginners curious about the snatch and clean & jerk",
      "Experienced lifters looking for programmed percentages and coaching eyes",
      "Anyone who wants to move better under load",
    ],
    session: [
      { name: "Positions & Mobility", detail: "Prep the ankles, hips and shoulders for receiving positions.", mins: "10 min" },
      { name: "Technique Drills", detail: "Pulls, hangs and power variations to groove the bar path.", mins: "15 min" },
      { name: "Main Lift", detail: "Snatch or clean & jerk at programmed percentages with individual feedback.", mins: "25 min" },
      { name: "Strength Accessory", detail: "Squats, pulls and overhead stability to build the engine behind the lift.", mins: "10 min" },
    ],
    scheduleNote: "Saturday 6:30 AM & 8:00 AM with Coach Miguel",
    priceNote: "Included in the Platinum Membership. Also available via punch cards.",
    coachName: "Miguel Claravall",
    faqs: [
      { q: "Is Olympic weightlifting only for advanced athletes?", a: "No. Beginners learn with a PVC pipe or empty barbell using drills and progressions before adding load." },
      { q: "Do I need to be flexible?", a: "You need enough mobility to reach the positions you train, and we help you build it. You don't need perfect mobility to start." },
      { q: "Do I need weightlifting shoes?", a: "Flat, stable shoes are fine at first. Lifting shoes can help later, but they're no substitute for coaching." },
      { q: "What's the difference between powerlifting and Olympic lifting?", a: "Powerlifting contests the squat, bench and deadlift. Olympic weightlifting contests the snatch and clean & jerk — faster, more technical lifts." },
    ],
    relatedArticle: "olympic-weightlifting-beginners-boston",
  },
  {
    slug: "powerlifting",
    metaDescription: "Powerlifting classes in West Roxbury: squat, bench, deadlift and strict press with coached progressions — Tue & Thu 9:30 AM, Wed & Fri 6:30 AM. All levels.",
    offerPrice: "275",
    name: "Powerlifting",
    short: "Westie Barbell Club: Deadlift, Squat, Strict Press and Bench Press with focused accessory work.",
    image: IMG.womens,
    heroLabel: "Westie Barbell Club",
    answer:
      "Powerlifting at Boston Iron Grit is a Westie Barbell Club class in West Roxbury built around four lifts: Deadlift, Squat, Strict Press and Bench Press, plus accessory movements that complement our strength development program. It started as a women's class and became popular with everyone. Tuesday & Thursday 9:30 AM, Wednesday & Friday 6:30 AM.",
    whoFor: [
      "Anyone who wants to get seriously strong with a barbell",
      "First-time lifters — every lift starts with technique at light loads",
      "Athletes who want structured strength work alongside CrossFit or HYROX",
      "Members chasing physique goals through real strength development",
    ],
    session: [
      { name: "Prep & Activation", detail: "Targeted warm-up for the day's main lift.", mins: "10 min" },
      { name: "Main Lift", detail: "Deadlift, squat, strict press or bench press at programmed progressions.", mins: "25 min" },
      { name: "Accessory Work", detail: "Complementary movements that build the strength program.", mins: "20 min" },
      { name: "Core & Cool-Down", detail: "Trunk work and mobility to finish.", mins: "5 min" },
    ],
    scheduleNote: "Tue & Thu 9:30 AM · Wed & Fri 6:30 AM",
    priceNote: "Included in the Platinum Membership. Also on the 24-session HYROX punch card (members $480 / new athletes $600).",
    coachName: "Marc Tucker",
    faqs: [
      { q: "Do I need lifting experience to join?", a: "No. Every lift starts with technique work at light loads, and progressions are individual." },
      { q: "What lifts does the program cover?", a: "Four main lifts — Deadlift, Squat, Strict Press and Bench Press — plus accessory movements that complement the strength program." },
      { q: "Is this a women's class?", a: "It started as a women's class and became popular with the fellas too — everyone is welcome." },
      { q: "Can I compete in powerlifting?", a: "Members who want to compete get meet-prep guidance; everyone else just gets strong." },
    ],
    relatedArticle: "crossfit-weight-loss-muscle-gain",
  },
  {
    slug: "hyrox-hybrid-core-zone-2",
    metaDescription: "HYROX-Hybrid Core & Zone 2 class in West Roxbury — Saturday 9:30 AM race-prep training with Coach Miguel: zone 2 conditioning, core strength, breathing and skills for long-endurance racing.",
    offerPrice: "275",
    name: "HYROX-Hybrid Core & Zone 2",
    short: "Saturday race-prep: zone 2 engine work, core strength, breathing and skills for hybrid racing.",
    image: IMG.rower,
    heroLabel: "Saturday Race Prep",
    answer:
      "HYROX-Hybrid Core & Zone 2 is our Saturday 9:30 AM race-prep session at Boston Iron Grit in West Roxbury. Coach Miguel (CF-L3) combines zone 2 aerobic conditioning, core strength, hip mobility, breathing work and race skills — with individual and partner formats that simulate race-day tactics for HYROX and other hybrid events.",
    whoFor: [
      "HYROX athletes preparing for race day — especially HYROX Boston",
      "Hybrid athletes who want a structured weekly zone 2 session",
      "CrossFitters building the aerobic base that makes everything else easier",
      "Anyone who wants core strength and breathing mechanics coached properly",
    ],
    session: [
      { name: "Hip Opening & Prep", detail: "Mobility and activation targeting the hips and trunk before endurance work.", mins: "10 min" },
      { name: "Skills & Breathing", detail: "Race-specific skills and breathing training for long-endurance efforts.", mins: "15 min" },
      { name: "Zone 2 Engine Block", detail: "Steady aerobic work across erg, run and station movements — individual and partner formats.", mins: "25 min" },
      { name: "Core Finisher", detail: "Focused trunk strength that transfers to sleds, carries and wall balls.", mins: "10 min" },
    ],
    scheduleNote: "Saturday 9:30 AM with Coach Miguel",
    chalkitKey: "hyroxPunch24",
    priceNote: "Covered by the HYROX add-on ($50/mo for current members) or the 24-session punch cards.",
    coachName: "Miguel Claravall",
    faqs: [
      { q: "What is zone 2 training?", a: "Zone 2 is steady aerobic work at a pace where you can still hold a conversation — roughly 60–70% of max heart rate. It builds the mitochondrial base that powers endurance racing and speeds recovery between hard efforts." },
      { q: "Do I need to be training for HYROX to join?", a: "No. The session benefits anyone who wants a stronger aerobic engine and better core strength. Many members come simply because it makes their weekday training feel easier." },
      { q: "How is this different from the Tuesday/Thursday HYROX classes?", a: "Tuesday and Thursday focus on race stations and compromised running at intensity. Saturday is the aerobic and skills complement — zone 2 pacing, breathing, hip mobility and partner race tactics." },
      { q: "Who coaches this class?", a: "Coach Miguel Claravall (CF-L3), who combines years of Olympic lifting coaching with breathing and movement work drawn from his martial arts background." },
      { q: "What should I bring?", a: "Regular training shoes, water and something to track your heart rate if you have it. Everything else — ergs, sleds, cores of steel — is provided." },
    ],
    relatedArticle: "zone-2-training-guide",
  },
  {
    slug: "big-engine",
    metaDescription: "B.I.G. Engine & Body Shop is Coach B's Sunday conditioning class in West Roxbury — lifting, gymnastics and cardio in one 30–45 minute engine-builder.",
    offerPrice: "275",
    name: "B.I.G. Engine & Body Shop",
    short: "Coach B's Sunday endurance builder — lifting, gymnastics and cardio in one unique 30–45 minute workout.",
    image: IMG.rower,
    badge: IMG.bigEngineLogo,
    heroLabel: "Sunday Engine Builder",
    answer:
      "B.I.G. Engine & Body Shop is Boston Iron Grit's Sunday conditioning class in West Roxbury — developed by Coach B to meet the long cardiovascular endurance element of training. Each 30–45 minute workout brings lifting, gymnastics and cardio together; every week is unique and never dull. Sundays at 8:00 and 10:00 AM.",
    whoFor: [
      "Athletes who want a bigger aerobic engine",
      "HYROX racers building long, steady capacity",
      "Members who love a fun, testing Sunday sweat",
      "Anyone bored of the same cardio routine — every workout is unique",
    ],
    session: [
      { name: "Briefing & Warm-Up", detail: "Coach B walks through the day's unique combination and pacing plan.", mins: "10 min" },
      { name: "The Engine Block", detail: "Lifting, gymnastics and cardio blended into one long endurance piece.", mins: "30–45 min" },
      { name: "Cool-Down", detail: "Zone 2 flush and mobility to finish.", mins: "10 min" },
    ],
    scheduleNote: "Sunday 8:00 AM & 10:00 AM",
    priceNote: "Included in the Platinum Membership. Also on the 24-session HYROX punch card (members $480 / new athletes $600).",
    coachName: "Brian Conroy (Coach B)",
    faqs: [
      { q: "What is B.I.G. Engine & Body Shop?", a: "A Sunday conditioning class developed by Coach B that blends lifting, gymnastics and cardio into a 30–45 minute endurance workout. It has become one of our most popular classes." },
      { q: "Is it beginner friendly?", a: "Yes — like everything at Boston Iron Grit, every element scales to your level while keeping the intended stimulus." },
      { q: "Does it help with HYROX?", a: "Absolutely. The long cardiovascular endurance element is exactly what HYROX racing demands — many of our HYROX athletes anchor their week with it." },
      { q: "How long is the workout?", a: "The workout itself runs 30–45 minutes inside a one-hour class, and every week is different." },
    ],
    relatedArticle: "how-often-should-beginners-do-crossfit",
  },
  {
    slug: "fundamentals",
    metaDescription: "Beginner fundamentals at Boston Iron Grit: five private sessions covering the essential movements, plus an InBody scan and assessment, for $625.",
    offerPrice: "625",
    name: "Beginner Fundamentals",
    short: "Your on-ramp. A free goal review plus five private sessions — assessment, Olympic lifts and gymnastics basics.",
    image: IMG.fundamentals,
    heroLabel: "Start Here",
    answer:
      "Fundamentals is the beginner on-ramp at Boston Iron Grit in West Roxbury. It starts with an assessment — a body composition test, a bodyweight strength test and an aerobic capacity test — then covers the two Olympic lifts and the basics of gymnastics with every scaling option you can grow into. We're with you every step of the way.",
    whoFor: [
      "Complete beginners who have never touched a barbell",
      "Anyone returning to training after years away",
      "People nervous about jumping into a group class",
      "Athletes with old injuries who need a careful ramp-up",
    ],
    session: [
      { name: "Goal Review", detail: "We learn your goals, training history and any limitations. Free, no pressure.", mins: "Free" },
      { name: "The Assessment", detail: "Body composition test, bodyweight strength test and aerobic capacity test set your baseline.", mins: "Session 1" },
      { name: "The Olympic Lifts", detail: "Learn the clean & jerk and the snatch safely, from the ground up.", mins: "Sessions 2–3" },
      { name: "Gymnastics & Scaling", detail: "Push-ups, pull-ups and all the scaling options you’ll tap into as you build capacity.", mins: "Sessions 4–5" },
    ],
    scheduleNote: "Scheduled around you — mornings, noon or evenings.",
    chalkitKey: "fundamentals",
    priceNote: "Free goal review to start · 5 private sessions $625 (includes InBody analysis & assessment).",
    coachName: "Tina Ramos & Yohanna",
    faqs: [
      { q: "Do I need to be fit before fundamentals?", a: "No. The entire purpose of fundamentals is to start with the fitness and movement you have today." },
      { q: "How fast can I finish fundamentals?", a: "Most people complete the five sessions in two to three weeks, then join group classes." },
      { q: "Can I skip fundamentals?", a: "Experienced CrossFit athletes can. New athletes get far more from class — and stay safer — after the on-ramp." },
      { q: "What happens after fundamentals?", a: "You join regular classes with any membership. Your coach recommends a starting schedule, usually 2–3 days per week." },
    ],
    relatedArticle: "first-crossfit-class-boston",
  },
  {
    slug: "open-gym",
    metaDescription: "Open gym at Boston Iron Grit in West Roxbury, Monday to Friday 10:30–11:30 AM. Train your own program with full access to racks, barbells and cardio gear.",
    offerPrice: "275",
    name: "Open Gym",
    short: "Full access to the space, rig and barbells. Train on your schedule with your plan.",
    image: IMG.hero,
    heroLabel: "Train Your Way",
    answer:
      "Open Gym at Boston Iron Grit gives self-directed athletes full access to our West Roxbury facility — rig, barbells, machines and specialty equipment — Monday through Friday, 10:30 to 11:30 AM, with afternoon times coming soon. Follow your own program or ask a coach to write one for you.",
    whoFor: [
      "Experienced athletes following their own programming",
      "Members who want extra skill or accessory work outside class",
      "Powerlifters and weightlifters who need platform time",
      "Shift workers who can't make fixed class times",
    ],
    session: [
      { name: "Your Plan", detail: "Follow your own program, or have a coach write one for your goals.", mins: "—" },
      { name: "Full Equipment", detail: "Rig, platforms, barbells, dumbbells, sleds, rowers, bikes and skis.", mins: "—" },
      { name: "Coach On Site", detail: "A coach is always in the building if you need a spot or a cue.", mins: "—" },
      { name: "Community", detail: "Train alongside members putting in extra work — good energy, no waiting for a squat rack.", mins: "—" },
    ],
    scheduleNote: "Mon–Fri 10:30 – 11:30 AM · afternoon times coming soon",
    priceNote: "Included with the Platinum Membership — ask us about standalone access.",
    coachName: "Staffed hours",
    faqs: [
      { q: "Can beginners use open gym?", a: "We recommend beginners complete fundamentals and build sound movement in classes first, then add open gym volume." },
      { q: "Is a coach available during open gym?", a: "A coach is always in the building. Open gym isn't a coached session, but you're never training in an empty warehouse." },
      { q: "Can I do my own program?", a: "Yes — that's the point. We can also write individualized programming for you at an additional cost." },
      { q: "Do drop-in visitors get open gym?", a: "Visiting athletes can add open gym access to a drop-in — just ask when you book." },
    ],
    relatedArticle: "crossfit-vs-regular-gym-boston",
  },
  {
    slug: "personal-training",
    metaDescription: "One-on-one personal training in West Roxbury: one coach, one plan built around your goals, schedule and history. Packages start at 5 sessions for $750.",
    offerPrice: "750",
    name: "Personal Training",
    short: "One coach, one athlete, one plan. Fully individualized programming around your goals.",
    image: IMG.pt,
    heroLabel: "1-on-1 Coaching",
    answer:
      "Personal training at Boston Iron Grit gives you a dedicated coach in West Roxbury and a program built entirely around your goals, schedule and history. Sessions are private, flexible and progress-tracked. Many athletes combine private sessions with group classes in a hybrid plan.",
    whoFor: [
      "Anyone who wants a program built specifically around their goals",
      "People who prefer privacy or need focused skill development",
      "Athletes preparing for a specific event, sport or competition",
      "Those working around injuries who need individualized planning",
    ],
    session: [
      { name: "Assessment", detail: "Movement screen, training history and goal setting on day one.", mins: "Session 1" },
      { name: "Individual Program", detail: "A written plan that adapts weekly based on your progress.", mins: "Ongoing" },
      { name: "Coached Sessions", detail: "Full attention of your coach — technique, load and pacing dialed in.", mins: "60 min" },
      { name: "Progress Reviews", detail: "Monthly check-ins with measurable markers, including InBody scans.", mins: "Monthly" },
    ],
    scheduleNote: "Booked around your calendar — early mornings through evenings.",
    chalkitKey: "pt5",
    priceNote: "Packages: 5 sessions $750 · 10 sessions $1,250 · 15 sessions $1,500.",
    coachName: "All coaches",
    faqs: [
      { q: "Is personal training better than CrossFit classes?", a: "Neither is universally better. Personal training maximizes individual attention; classes add community and cost less per session. Many members do both." },
      { q: "Can a trainer prepare me for group classes?", a: "Yes — many members start privately, build confidence, then transition into classes." },
      { q: "How often should I train privately?", a: "One to three sessions weekly is common, often mixed with classes or open gym in a hybrid plan." },
      { q: "Do you offer small-group private training?", a: "Yes. Train with a friend or two and split the cost — ask at your goal review." },
    ],
    relatedArticle: "crossfit-vs-personal-training-boston",
  },
  {
    slug: "nutrition-coaching",
    metaDescription: "Habit-based nutrition coaching in West Roxbury with monthly InBody body composition scans — built to work with your training and your real life.",
    name: "Nutrition Coaching",
    short: "Habit-based nutrition coaching with monthly InBody scans. Fuel the work you put in.",
    image: IMG.nutrition,
    heroLabel: "Fuel The Work",
    answer:
      "Nutrition coaching at Boston Iron Grit pairs you with a coach in West Roxbury for habit-based nutrition support: weekly check-ins, realistic meal frameworks and a monthly InBody scan to track trends. No crash diets — sustainable changes that support fat loss, muscle gain and performance.",
    whoFor: [
      "Members training hard but not seeing body-composition change",
      "Anyone tired of all-or-nothing dieting cycles",
      "Athletes fueling for performance, not just weight",
      "Busy parents and professionals who need realistic frameworks",
    ],
    session: [
      { name: "Intake & InBody", detail: "Baseline body composition scan and an honest conversation about habits.", mins: "Week 1" },
      { name: "Habit Framework", detail: "Protein targets, meal structure and grocery strategies that fit your life.", mins: "Ongoing" },
      { name: "Weekly Check-Ins", detail: "Accountability, adjustments and troubleshooting with your coach.", mins: "Weekly" },
      { name: "Monthly Scan", detail: "InBody trends reviewed together — data, not guilt.", mins: "Monthly" },
    ],
    scheduleNote: "Check-ins scheduled around you — in person or remote.",
    chalkitKey: "big365",
    priceNote: "Part of Live B.I.G. 365 — $100/month, included free with the Platinum Membership.",
    coachName: "Tina Ramos",
    faqs: [
      { q: "Do you prescribe meal plans?", a: "We build frameworks and habits rather than rigid meal plans — they last longer. Clinical nutrition needs are referred to licensed professionals." },
      { q: "Do I need to be a member?", a: "No. Nutrition coaching is open to non-members, though it pairs powerfully with training here." },
      { q: "How fast will I see results?", a: "There's no responsible universal timeline. We track monthly trends in the InBody data and adjust based on what your body actually does." },
      { q: "Is this for weight loss only?", a: "No — muscle gain, performance fueling and maintenance goals all get individualized attention." },
    ],
    relatedArticle: "crossfit-weight-loss-muscle-gain",
  },
  {
    slug: "inbody-testing",
    metaDescription: "InBody body composition testing in West Roxbury: muscle mass, body fat and visceral fat measured in minutes, with a coach walkthrough of your results.",
    name: "Body Composition Testing",
    short: "Medical-grade body composition analysis. Know your baseline, track real trends.",
    image: IMG.coach,
    heroLabel: "Know Your Numbers",
    answer:
      "InBody testing at Boston Iron Grit uses bioelectrical impedance analysis to estimate skeletal muscle mass, body fat percentage and segmental lean mass. Scans take under a minute in our West Roxbury gym. Every scan includes a coach walkthrough of what the numbers mean — and what they don't.",
    whoFor: [
      "Anyone starting a fitness or nutrition program who wants a baseline",
      "Members tracking recomposition — losing fat while gaining muscle",
      "Athletes monitoring training-block progress",
      "People who want more context than the bathroom scale",
    ],
    session: [
      { name: "The Scan", detail: "Under 60 seconds on the InBody unit. No pinching, no dunking.", mins: "1 min" },
      { name: "The Report", detail: "Muscle mass, fat mass, body fat %, segmental analysis and body water.", mins: "Instant" },
      { name: "Coach Review", detail: "We explain which metrics matter for your goal — and which to ignore.", mins: "10 min" },
      { name: "Trend Tracking", detail: "Repeat under similar conditions monthly or quarterly for meaningful trends.", mins: "Ongoing" },
    ],
    scheduleNote: "By appointment, any staffed hour.",
    priceNote: "Included with your free goal review · special pricing via Live B.I.G. 365.",
    coachName: "Tina Ramos",
    faqs: [
      { q: "Is an InBody scan accurate?", a: "It provides estimates that are useful when testing conditions are consistent — same time of day, similar hydration. No single method is perfect." },
      { q: "How should I prepare?", a: "Avoid heavy meals, intense exercise and large fluid intake right before scanning. Consistency matters more than perfection." },
      { q: "Can it diagnose a health condition?", a: "No. An InBody scan is not a medical assessment. People who are pregnant or have implanted electronic devices should consult a professional first." },
      { q: "How often should I scan?", a: "Monthly or quarterly is typical — enough time for a meaningful trend to develop." },
    ],
    relatedArticle: "inbody-scan-boston-guide",
  },
  {
    slug: "50-plus-fitness",
    metaDescription: "Strength and mobility training for adults 50 and up in West Roxbury — coached sessions that build muscle, bone density and balance at your pace.",
    offerPrice: "275",
    name: "50+ Fitness",
    short: "Strength and mobility for adults 50 and up. Train for the next 30 years.",
    image: IMG.senior,
    heroLabel: "Legends Program",
    answer:
      "50+ Fitness at Boston Iron Grit is coached strength and mobility training in West Roxbury for adults fifty and older. Sessions emphasize movement quality, gradual loading, balance and recovery — matched to your health history. No prior training experience required. It starts with a free goal review.",
    whoFor: [
      "Adults 50+ who want to build or maintain strength and independence",
      "Complete beginners — most of our Legends started from zero",
      "Anyone told to 'lift weights' by their doctor and unsure where to start",
      "Retirees who love the mid-morning community",
    ],
    session: [
      { name: "Assessment First", detail: "We gather your history, goals and any limitations before you touch a weight.", mins: "Session 0" },
      { name: "Pattern Work", detail: "Squat, hinge, push, pull, carry — adjusted with boxes, bands and dumbbells.", mins: "25 min" },
      { name: "Balance & Capacity", detail: "Practical aerobic work and stability that transfers to daily life.", mins: "20 min" },
      { name: "Mobility", detail: "Guided flexibility and recovery work to finish.", mins: "10 min" },
    ],
    scheduleNote: "Best fit: 9:30 AM & Noon classes, scaled individually",
    priceNote: "Included in all class memberships. Private options available.",
    coachName: "Tina Ramos & Yohanna",
    faqs: [
      { q: "Am I too old to start strength training?", a: "Age alone is not a disqualifier. Your starting point and progression should reflect your individual health and ability — that's exactly what we assess first." },
      { q: "Is CrossFit safe for adults over 50?", a: "Many adults over 50 train here safely with appropriate coaching and scaling. Anyone with medical concerns should consult their healthcare professional first." },
      { q: "What if I've never lifted weights?", a: "Perfect — you'll learn basic patterns with a coach before any meaningful load is added." },
      { q: "Do I train with 25-year-olds?", a: "Classes are mixed and everyone does their own scaled version. The 9:30 AM crew skews 45+, if you prefer training with peers." },
    ],
    relatedArticle: "strength-training-over-50-boston",
  },
];

// ---------------- HYROX ----------------
// Next 8-week prep block — update this ONE date when a new block is announced
export const NEXT_HYROX_BLOCK = "2026-10-20";
const _hyroxBlockDate = new Date(`${NEXT_HYROX_BLOCK}T12:00:00-04:00`);
export const HYROX_BLOCK_TEXT =
  Date.now() < _hyroxBlockDate.getTime()
    ? _hyroxBlockDate.toLocaleDateString("en-US", { weekday: "long", month: "long", day: "numeric" })
    : null;
export const HYROX_PREP_LINE = HYROX_BLOCK_TEXT
  ? `8-Week HYROX Prep for new members starts ${HYROX_BLOCK_TEXT}.`
  : "New 8-week prep blocks start monthly. Ask a coach for the next start date.";
export const HYROX_RACE_PAST = Date.now() > new Date("2026-10-11T23:59:59-04:00").getTime();
export const HYROX_NAV_SUB = HYROX_RACE_PAST ? "Race prep year-round" : "Boston race · Oct 8–11";

export const HYROX = {
  stations: [
    { num: "01", name: "1km SkiErg", detail: "Full-body pull power right after your first run." },
    { num: "02", name: "50m Sled Push", detail: "152kg (men) / 102kg (women) of pure leg drive." },
    { num: "03", name: "50m Sled Pull", detail: "Grip, hamstrings and back — backwards." },
    { num: "04", name: "80m Burpee Broad Jumps", detail: "The station that breaks pacing plans." },
    { num: "05", name: "1km Row", detail: "Find rhythm and recover — if you paced it right." },
    { num: "06", name: "200m Farmers Carry", detail: "2x24kg / 2x16kg kettlebells. Grip check." },
    { num: "07", name: "100m Sandbag Lunges", detail: "20kg / 10kg sandbag. Quads on fire." },
    { num: "08", name: "100 Wall Balls", detail: "The final boss. 6kg / 4kg to target." },
  ],
  divisions: [
    { name: "Open", detail: "The standard race — most first-timers start here." },
    { name: "Pro", detail: "Heavier weights for competitive athletes." },
    { name: "Doubles", detail: "Share the stations with a partner. Both run every kilometer." },
    { name: "Relay", detail: "Teams of four split the race. Perfect entry point." },
  ],
  race: {
    name: "HYROX Boston",
    dates: "October 8–11",
    prep: HYROX_PREP_LINE,
  },
  offers: [
    { name: "Member Add-On · Members Only", price: "$50/mo", detail: `Current members: add HYROX training to any membership, month to month. ${HYROX_RACE_PAST ? "Next race season: training starts now." : "Train for HYROX Boston, October 8–11."}`, chalkitKey: "hyroxAddOn" },
    { name: "Punch Card · Members Only", price: "$480", detail: "24 sessions at the members-only discount — valid across B.I.G. Engine, Powerlifting, HYROX Comp Prep and Skills Development.", chalkitKey: "hyroxPunchMembers" },
    { name: "Punch Card · New Athletes", price: "$600", detail: `24 sessions covering B.I.G. Engine, Powerlifting, HYROX Comp Prep and Skills Development — ${HYROX_BLOCK_TEXT ? `includes the 8-week prep block starting ${HYROX_BLOCK_TEXT}` : "new 8-week prep blocks start monthly; ask a coach for the next start date"}.`, chalkitKey: "hyroxPunch24" },
  ],
  program: [
    { name: "HYROX Classes", when: "Tue & Thu 6:30 AM", detail: "Race-specific station work, compromised running and pacing with Coaches Tina & Kate." },
    { name: "HYROX-Hybrid Core & Zone 2", when: "Saturday 9:30 AM", detail: "Coach Miguel (CF-L3) combines hip opening, skills and breathing training for long-endurance racing — individual and partner work that simulates race-day tactics." },
    { name: "B.I.G. Engine", when: "Sun 8:00 & 10:00 AM", detail: "Coach B's endurance builder — lifting, gymnastics and cardio for your race engine." },
    { name: "Powerlifting Strength", when: "Tue/Thu 9:30 AM · Wed/Fri 6:30 AM", detail: "Westie Barbell Club strength work — sleds, carries and wall balls love a strong base." },
  ],
  faqs: [
    { q: "What is HYROX?", a: "HYROX is an indoor fitness race: 8x 1km runs, each followed by a functional workout station — SkiErg, sled push, sled pull, burpee broad jumps, rowing, farmers carry, sandbag lunges and wall balls. Every race worldwide is identical, so times are comparable." },
    { q: "Do I need to be a runner?", a: "You need to run 8km total, but at a controlled pace between stations. Our endurance sessions build exactly this kind of compromised running." },
    { q: "Can beginners train for HYROX?", a: "Yes. The Open and Relay divisions are very accessible, and every station scales in training. Many members train HYROX-style without ever racing." },
    { q: "Is HYROX training different from CrossFit?", a: "HYROX is longer, steadier aerobic work with no complex barbell movements. CrossFit builds broad fitness; our HYROX sessions sharpen it into race-specific capacity. They complement each other well." },
    { q: "Which race should I target?", a: HYROX_RACE_PAST ? `Next race season: training starts now — HYROX Club runs year-round between seasons. ${HYROX_PREP_LINE}` : `Our home target is HYROX Boston, October 8–11 — most of our athletes are training for it right now. ${HYROX_BLOCK_TEXT ? `New members can join the 8-week prep block starting ${HYROX_BLOCK_TEXT}.` : "New 8-week prep blocks start monthly. Ask a coach for the next start date."}` },
    { q: "What is a good HYROX time?", a: "Elite men finish around or under 60 minutes and elite women near 65. A competitive amateur time is 75–90 minutes, and a typical first race lands between 90 and 105 minutes. Finishing your first HYROX at any pace puts you ahead of everyone who never started." },
    { q: "How long do I need to train for HYROX?", a: "With a base of general fitness, 8 weeks of race-specific training is enough for a strong first race — that's exactly why our prep block is 8 weeks. Starting from scratch, give yourself 12–16 weeks and begin with our beginner fundamentals." },
    { q: "What should I bring on race day?", a: "Grippy training shoes (not cushioned racing shoes — you're pushing sleds), a shirt you can sweat through, and nutrition you've practiced with in training. Chalk is provided, gloves are a personal call, and arrive at least 90 minutes before your start time." },
    { q: "How much does HYROX training cost at Boston Iron Grit?", a: "Current members add HYROX for $50/month, or grab the members-only 24-session punch card for $480. New athletes buy the 24-session punch card for $600 — all valid across B.I.G. Engine, Powerlifting, HYROX Comp Prep and Saturday race-prep classes." },
    { q: "Is there a HYROX gym near Dedham, Needham or Newton?", a: "Yes. Boston Iron Grit is on VFW Parkway in West Roxbury, a short drive from Dedham, Needham, Newton, Roslindale and Brookline, with free on-site parking." },
    { q: "Do you have sleds, SkiErgs and rowers for HYROX training?", a: "Yes. Sled push and pull at race weight, SkiErgs, rowers, sandbags and wall-ball targets are programmed every week." },
    { q: "Can I train HYROX if I'm over 50?", a: "Yes. The Open and Relay divisions are accessible, and every station scales. Many members 50+ train with us." },
  ],
};

export const FORM_INTERESTS = [
  "Free Goal Review",
  "Fundamentals (Beginner)",
  "Experienced Athlete",
  "Drop In / Visiting",
  "Personal Training",
  "HYROX Training",
  "Live B.I.G. 365 (Wellness)",
  "Peptides / GLP-1s & Live B.I.G. 365",
  "Nutrition Coaching",
  "Gold Standard Programs",
  "Other",
];

// ---------------- Live B.I.G. 365 — Wellness & Longevity Program ----------------
export const BIG365 = {
  price: "$100",
  per: "/month",
  creator: "Tina Ramos",
  answer:
    "Live B.I.G. 365 is Boston Iron Grit's road map to longevity and wellness — over five years in the making. We offer body composition testing, labs, peptides and GLP-1s through licensed providers, and supplements from Designs for Health. All services are discounted for B.I.G. members. $100/month, included free with the Platinum Membership.",
  areas: [
    { name: "Train", blurb: "Movement is medicine — move every day with purpose and intent. It doesn't have to be a beat-down every day." },
    { name: "Nourish", blurb: "Keep it simple: protein, veggies, fiber, hydrate. Nourish your body and feed your soul — no cheat days, no punishment." },
    { name: "Connect", blurb: "Protect your sleep, live mostly zero proof, and stay connected — recovery is where the gains happen." },
  ],
  challenge: "We also run fun 8-week challenges to jump-start your daily routine in a supportive, slightly competitive group.",
  habits: [
    { num: "01", area: "Train", name: "Move Your Body", detail: "Move every day with purpose — a mix of Zone 2, weightlifting and the occasional burn-it-down WOD to keep the systems in check." },
    { num: "02", area: "Train", name: "Mobility", detail: "15 minutes a day goes a long way in keeping you injury-free and supple." },
    { num: "03", area: "Nourish", name: "Protein", detail: "Find the right daily amount for you and divide it by four — simple, steady protein across the day hits this important macro." },
    { num: "04", area: "Nourish", name: "Fiber", detail: "Six servings of vegetables and two servings of fruit every day, plus two to four servings of healthy grains and legumes." },
    { num: "05", area: "Nourish", name: "Hydrate", detail: "Your body is 50–60% water. Build from a 64-ounce base — water, herbal teas and broths all count toward daily hydration." },
    { num: "06", area: "Connect", name: "Sleep & Daylight", detail: "Keep a consistent, screen-free bedtime — aim for 6–8 hours. Morning daylight sets the circadian rhythm your body is wired for." },
    { num: "07", area: "Connect", name: "Zero Proof", detail: "Most days alcohol-free, and skip the added-sugar processed stuff. It banks longevity, aids muscle recovery and keeps the brain healthy — and it isn't boring." },
    { num: "08", area: "Connect", name: "Community", detail: "We're social creatures — the B.I.G. community is one of your strongest connections, and we're here to support you." },
  ],
  pillars: [
    {
      name: "Labs & Bloodwork",
      tag: "Know your baseline",
      detail: "Comprehensive lab panels and body composition tracking so decisions are driven by your data, not guesswork.",
      points: ["Comprehensive blood panels", "InBody body composition tracking", "Quarterly retesting to measure change", "Special member pricing"],
    },
    {
      name: "Peptides & GLP-1s",
      tag: "Provider-guided",
      detail: "Access to peptide and GLP-1 protocols through licensed medical partners, with eligibility screening and coach support alongside your training.",
      points: ["Licensed provider consultations", "Eligibility screening required", "Coaching support during protocols", "Special member pricing"],
    },
    {
      name: "Supplements",
      tag: "Only what works",
      detail: "Professional-grade supplements from Designs for Health, matched to your labs and goals.",
      points: ["Designs for Health lineup", "Matched to your lab results", "Professional-grade quality", "Discounted for B.I.G. members"],
    },
    {
      name: "Recovery",
      tag: "Rebuild daily",
      detail: "Mobility work, breathwork, sleep coaching and structured deload guidance so you can train hard for decades.",
      points: ["Guided mobility & cooldowns", "Sleep & stress habits", "Deload & recovery planning", "Coach check-ins"],
    },
  ],
  steps: [
    { name: "Free Goal Review", detail: "A 20-minute conversation about your goals, history and health priorities." },
    { name: "Baseline: Labs + InBody", detail: "Blood panel and body composition scan set your starting line." },
    { name: "Your Protocol", detail: "Habits, training, nutrition — plus provider-guided options where appropriate." },
    { name: "8 Daily Habits", detail: "Daily challenges, journals and check-ins keep the plan alive between visits." },
    { name: "Retest & Tune", detail: "Quarterly labs and scans measure what changed. We adjust and go again." },
  ],
  faqs: [
    { q: "What is Live B.I.G. 365?", a: "Live B.I.G. 365 is Boston Iron Grit's road map to longevity and wellness: 8 daily habits, body composition testing, labs, peptides and GLP-1s through licensed providers, and supplements from Designs for Health — $100/month, included free with the Platinum Membership. All services are discounted for B.I.G. members." },
    { q: "Do I need to be a gym member to join?", a: "No. Live B.I.G. 365 is open to non-members at $100/month, and it's included free with the Platinum Membership ($275/month)." },
    { q: "Are peptides and GLP-1s included in the price?", a: "The program includes access and special member pricing. Peptides, GLP-1s and lab panels are provided through licensed medical partners and billed separately after a provider consultation and eligibility screening." },
    { q: "Is this medical care?", a: "No. Live B.I.G. 365 coaching supports habits, training and recovery. All medical services — labs, peptides, GLP-1s — run through licensed providers who determine eligibility. Always consult your physician about medical decisions." },
    { q: "What are the 8 daily habits?", a: "Move Your Body, Mobility, Protein, Fiber, Hydrate, Sleep & Daylight, Zero Proof and Community — grouped into three areas (Train, Nourish, Connect) and tracked through 8-week challenges, journals and (soon) our app." },
    { q: "When does the app launch?", a: "The Live B.I.G. 365 app — with daily habit challenges, journals and nutrition advice — is in development. Join the waitlist and you'll be first in when it drops." },
  ],
};


// ---------------- Free Goal Review scheduling (typical availability) ----------------
export const GOAL_REVIEW_SLOTS = [
  { day: "Monday", times: ["9:00 AM", "4:30 PM"] },
  { day: "Tuesday", times: ["6:00 AM", "11:30 AM"] },
  { day: "Wednesday", times: ["7:30 AM", "9:00 AM", "6:00 PM"] },
  { day: "Thursday", times: ["9:00 AM", "11:30 AM", "6:00 PM"] },
  { day: "Friday", times: ["7:30 AM", "5:30 PM"] },
  { day: "Sunday", times: ["9:30 AM"] },
];

// ---------------- Gold Standard Programs (high-ticket coaching tiers) ----------------
export const GOLD_STANDARD = {
  title: "Gold Standard Programs",
  tagline: "Performance, Longevity and Avidity",
  blurb:
    "Take your training to the next level. Every Gold Standard program includes personal training and labs, accommodates the 50+ athlete, and is the best place to start for anyone interested in peptides and GLP-1s.",
  platinum: {
    name: "Platinum Membership",
    price: "$275",
    per: "/month",
    detail:
      "Price reduces to $225/month when you start with our Gold Standard Programs — and you get 20% off labs, peptides and supplements for the lifetime of your membership.",
  },
  tiers: [
    {
      name: "The Foundation",
      price: "$1,985",
      save: "Save $200",
      term: "3-Month Program",
      chalkitKey: "goldFoundation",
      detail: "Your entry into fully guided training — personal training sessions, baseline labs and body composition, the 8 daily habits and a coach in your corner.",
      includes: ["Personal training sessions", "Baseline labs & InBody scan", "8 Daily Habits coaching", "Built for every age — 50+ welcome"],
      after: "Upon completion of the 3-month program: unlimited group classes at $225/month.",
    },
    {
      name: "The Ascension",
      price: "$2,525",
      save: "Save $460",
      term: "3-Month Program",
      chalkitKey: "goldAscension",
      detail: "More sessions, deeper testing and regular protocol reviews with our medical partners — built for meaningful transformation.",
      featured: true,
      includes: ["Everything in The Foundation", "More sessions & deeper testing", "Medical-partner protocol reviews", "Peptide & GLP-1 eligibility screening"],
      after: "Upon completion of the 3-month program: unlimited group classes at $225/month + 10% savings on labs, peptides and supplements.",
    },
    {
      name: "The Elite Performance",
      price: "$6,800",
      save: "Save $2,820",
      term: "6 Months of Complete Support",
      chalkitKey: "goldElite",
      detail: "Our most comprehensive coaching relationship — six months of complete support with provider-guided longevity protocols.",
      includes: [
        "12 private training sessions",
        "6 behavioral-change private sessions",
        "2 comprehensive labs",
        "6-month GLP-1 supply + 1 peptide — or 3 peptides",
        "6 body composition tests",
        "Meal prep support",
      ],
      after: "Upon completion of the 6-month program: unlimited group classes at $225/month + 20% savings on labs, peptides and supplements.",
    },
  ],
  note: "Lock in your tier at a free goal review — we'll match the program to your goals, history and labs.",
};
